<template>
    
    <div class="main">
        <el-tabs type="border-card" v-model="tabAtiva">
            <el-tab-pane label="ALERGIA" name="0">
                
                <list-alergia></list-alergia>

            </el-tab-pane>
            <el-tab-pane label="DOENÇA" name="1">
                
                <list-doenca></list-doenca>

            </el-tab-pane>
            <el-tab-pane label="DEFICIÊNCIA" name="2">
                
                <list-deficiencia></list-deficiencia>

            </el-tab-pane>
        </el-tabs>
    </div>
    
</template>
<script>

import listAlergia from "../alergia/list/list";
import listDoenca from "../doenca/list/list";
import listDeficiencia from "../deficiencia/list/list";

export default {
    data: () => ({
        tabAtiva: 0

    }),
    mounted(){ 

        this.tabAtiva = (this.$route.params.tab) ? this.$route.params.tab : 0;

    },
    methods:{
        tabSelected(){

        }
    },
    components:{ listAlergia, listDoenca, listDeficiencia }
}
</script>
